module.exports = __webpack_public_path__ + "media/nujabes-imaginary-folklore.c0247b1c.mp3";